import React from "react";
import { Button } from "antd";
const PageRegularLink = ({ link, isCustom, pageDetails }) => {
  if (isCustom) {
    return (
      <Button
        href={link.LinkUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="link-regular link-el"
        style={{
          backgroundColor: pageDetails.ButtonBackgroundColor,
          color: pageDetails.ButtonTextColor,
          borderRadius: pageDetails.ButtonBorderRadius,
        }}
      >
        {" "}
        <div className="link-details-page">
          <div className="link-display-page">
            <div className="link-display-icon">
              {/* {linkDetails.LinkType === "regular" && (
              <FaLink className="icon-link-admin" />
            )}
            {linkDetails.LinkType === "youtube-sub" && (
              <FaYoutubeSquare className="icon-link-admin" />
            )}
            {linkDetails.LinkType === "spotify" && (
              <FaSpotify className="icon-link-admin" />
            )}
            {linkDetails.LinkType === "soundcloud" && (
              <FaSoundcloud className="icon-link-admin" />
            )}
            {linkDetails.LinkType === "youtube-video" && (
              <FaYoutube className="icon-link-admin" />
            )} */}
            </div>
            <div className="link-display-title">{link.LinkTitle}</div>
          </div>
        </div>
      </Button>
    );
  } else {
    return (
      <Button
        href={link.LinkUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="link-regular link-el"
      >
        {" "}
        <div className="link-details-page">
          <div className="link-display-page">
            <div className="link-display-icon">
              {/* {linkDetails.LinkType === "regular" && (
              <FaLink className="icon-link-admin" />
            )}
            {linkDetails.LinkType === "youtube-sub" && (
              <FaYoutubeSquare className="icon-link-admin" />
            )}
            {linkDetails.LinkType === "spotify" && (
              <FaSpotify className="icon-link-admin" />
            )}
            {linkDetails.LinkType === "soundcloud" && (
              <FaSoundcloud className="icon-link-admin" />
            )}
            {linkDetails.LinkType === "youtube-video" && (
              <FaYoutube className="icon-link-admin" />
            )} */}
            </div>
            <div className="link-display-title">{link.LinkTitle}</div>
          </div>
        </div>
      </Button>
    );
  }
};

export default PageRegularLink;
